"use strict";

define('RaceUrlFac',['RaceParamsEntityBuilder', 'lodash'],function(RaceParamsEntityBuilder, _){

    /*
    * This fac will be use to handle races url decode and encode
    * */
    function RaceUrlFac($location, $routeParams, METADATA, racePerformances){

        function _searchMetadataTrackByName(trackName) {
            var track = _.find(METADATA.allTracks, function(track) {
                return trackName.toLowerCase() === track.Name.trim().toLowerCase();
            });
            return track;
        }

        function _searchPerformanceByPerformanceName(performance) {
            var perf = _.find(racePerformances, function(racePerformance){
                return racePerformance.fullPerf.toLowerCase() === performance.toLowerCase();
            });
            return perf;
        }

        function _searchMetadataTrackByAbbr(trackAbbr) {
            var track = _.find(METADATA.allTracks, function(track) {
                return trackAbbr.toLowerCase() === track.Abbreviation.toLowerCase();
            });
            return track;
        }

        function _searchPerformanceByPerfAbbr(perfAbbr) {
            var perf = _.find(racePerformances, function(racePerformance){
                return racePerformance.perfAbbr.toLowerCase() === perfAbbr.toLowerCase();
            });
            return perf;
        }

        /*
            this function will look to route params to calculate trackAbbr, perfAbbr, and raceNumber
         */
        function _getRacesInfoFromRouteParams() {
            var trackName = $routeParams.trackName || '';
            var trackPerformance = $routeParams.trackPerformance || '';
            var raceNumber = $routeParams.raceNumber || '';
            var track, trackPerf, raceId;

            //remove the race
            if (typeof raceNumber === "string") {
                raceNumber = raceNumber.replace('race-',"");
            }


            if (trackName){
                trackName = trackName.split('-').join(' ');
                track = _searchMetadataTrackByName(trackName);
            }

            trackPerf = _searchPerformanceByPerformanceName(trackPerformance);

            if (_.isUndefined(track) || _.isUndefined(trackPerf)){
                raceId = _buildRaceId($routeParams.trackName, $routeParams.trackPerformance, raceNumber);
                return RaceParamsEntityBuilder()
                    .withTrackAbbr(trackName)
                    .withPerfAbbr(trackPerformance)
                    .withRaceNumber(raceNumber)
                    .withRaceId(raceId)
                    .build();
            }

            raceId = _buildRaceId(track.Abbreviation, trackPerf.perfAbbr, raceNumber);

            return RaceParamsEntityBuilder().withTrackAbbr(track.Abbreviation)
                                            .withPerfAbbr(trackPerf.perfAbbr)
                                            .withRaceNumber(raceNumber)
                                            .withRaceId(raceId)
                                            .build();
        }

        /**
         * This function uses the '$location.path' function instead of the '$routeParams' service
         * to get the new URL parameters' values.
         * This is useful when we want to get these values before a route change occurs,
         * '$routeChangeStart' and '$routeChangeSuccess' events.
         *
         * @returns {Object} route params that match the 'racetracks' route.
         */
        function _getRouteParamsForRaceBasedOnLocationPath() {
            var routeParams = {};
            var currentPathArray = $location.path().split('/');

            routeParams.country = currentPathArray[2];
            routeParams.trackName = currentPathArray[3];
            routeParams.trackPerformance = currentPathArray[4];
            routeParams.raceNumber = currentPathArray[5];
            routeParams.autoplay = currentPathArray[7];

            return routeParams;
        }

        function _buildRaceId(trackName, trackPerformance, raceNumber) {
            if (trackName && trackPerformance && raceNumber ) {
                return trackName + '_' + trackPerformance + '_' + raceNumber;
            }
            return '';
        }

        function _getRouteParamsForRace(trackAbbr, perfAbbr, raceNumber, autoplay) {
            var track = trackAbbr ? _searchMetadataTrackByAbbr(trackAbbr) : undefined;
            var perf = perfAbbr ? _searchPerformanceByPerfAbbr(perfAbbr) : undefined;
            var race = raceNumber;
            var trackName;

            if (_.isUndefined(track) || _.isUndefined(perf) || _.isUndefined(race)){
                return {
                    autoplay: autoplay ? autoplay.toString() : undefined,
                    trackName: trackAbbr,
                    trackPerformance: perfAbbr,
                    country: 'unknown',
                    raceNumber: raceNumber
                };
            } else {
                trackName = track.Name.trim().replace(/\s/g,"-").toLowerCase();
                return {
                    autoplay: autoplay ? autoplay.toString() : undefined,
                    trackName: trackName,
                    trackPerformance: perf.fullPerf,
                    country: track.CountryName,
                    raceNumber: race
                };
            }
        }

        function _calculateRacePath(trackAbbr, perfAbbr, raceNumber, autoplay) {
            var routeParams = _getRouteParamsForRace(trackAbbr, perfAbbr, raceNumber, autoplay);
            if (routeParams.trackName && routeParams.trackPerformance && routeParams.raceNumber) {
                return ("/racetracks/" + routeParams.country +
                    "/" + routeParams.trackName +
                    "/" + routeParams.trackPerformance +
                    "/race-" + routeParams.raceNumber).concat(autoplay ? '/autoplay/' + autoplay.toString() : '');
            }
            return "/racetracks/unknown/unknown/unknown/unknown";
        }

        function _generateRacePath(trackName, raceNumber, countryName, autoplay) {
            trackName = trackName.trim().replace(/\s/g,"-").toLowerCase();

            if (trackName && raceNumber && countryName) {
                return ("/racetracks/" + ( countryName ? countryName : 'unknown' ) +
                    "/" + trackName +
                    "/race-" + raceNumber).concat(autoplay ? '/autoplay/' + autoplay.toString() : '');
            }
            return "/racetracks/unknown/unknown/unknown/unknown";
        }

        return {
            getRouteParamsForRace: _getRouteParamsForRace,
            getRouteParamsForRaceBasedOnLocationPath: _getRouteParamsForRaceBasedOnLocationPath,
            getRacesInfoFromRouteParams: _getRacesInfoFromRouteParams,
            calculateRacePath: _calculateRacePath,
            generateRacePath: _generateRacePath
        };
    }

    RaceUrlFac.$inject = [
        '$location',
        '$routeParams',
        'METADATA',
        'racePerformances'
    ];

    return RaceUrlFac;

});

